angular.module('cn')
.service('networksRepository', [
  '$http',
  '$q',
  '$rootScope',
  'ENV',
  function(
    $http,
    $q,
    $rootScope,
    ENV
  ) {

    var _getNetwork = function(id) {
      return $http({
        method: 'GET',
        url: `${ENV.EIAM_URL}/customernetworks/${id}`
      }).then(function(raw) {
        return raw.data.data;
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', 'Can not get network data');
        return $q.reject(err);
      });
    };

    var Account = function(network, item) {
      var tree = [];

      var _getAccountLevel = function(levels, acc) {
        if (acc.parent) {
          _getAccountLevel(levels, acc.parent);
          levels++;
        } else {
          return levels;
        }
      };

      var _refreshTotals = function(account, force) {
        if (account.totalAccounts === undefined || force) {
          account.totalAccounts = account.getTree().reduce(function(i, acc) {
            return i + _refreshTotals(acc, force);
          }, account.getTree().length);
        }
        return account.totalAccounts;
      };
      var relations = {
        senders: [],
        retailers: []
      };

      var account = {
        id: item.id,
        name: item.name,
        dateCreated: new Date(item.date_created),
        dateUpdated: new Date(item.date_updated),
        totalAccounts: undefined,
        network: network,
        photorankId: item.photorank_id,
        parent: undefined,
        refreshTotals: function(force) {
          _refreshTotals(account, force);
        },
        getSenders: function() {
          return relations.senders;
        },
        getRetailers: function() {
          return relations.retailers;
        },
        getSendersString: function() { // TODO this is representation, shouldn't be here
          if (relations.senders) {
            return relations.senders.map(function(a) {return a.name;}).join(', ');
          }
        },
        getRetailersString: function() { // TODO this is representation, shouldn't be here
          if (relations.retailers) {
            return relations.retailers.map(function(a) {return a.name;}).join(', ');
          }
        },
        pushRetailer: function(ret) {
          relations.retailers.push(ret);
        },
        removeRetailer: function(retailer) {
          relations.retailers.splice(relations.retailers.findIndex(function(ret) {
            return ret.relationId === retailer.relationId;
          }), 1);
        },
        setRelations: function(relationsPromise) {
          relationsPromise.then(function(rel) {
            relations.senders = rel.senders || [];
            relations.retailers = rel.retailers || [];
          });
        },
        getTree: function() {
          return tree;
        },
        getLevel: function() {
          return _getAccountLevel(account);
        },
        pushChildAccount: function(childAccount) {
          tree.push(childAccount);
        },
        findParent: function(accounts) {
          if (item.parent === null) {
            // root account -> its parent is the netowrk itself
            account.setParent(network);
          } else {
            // non-root
            account.setParent(accounts[accounts.findIndex(function(acc) {
              return acc.id === item.parent;
            })]);
          }
        },
        setParent: function(parent) {
          if (!parent) {
            throw new Error(`Cannot find the parent account ${item.parent} for the network: ${account.network.id}`);
          }
          account.parent = parent;
          if (parent.pushChildAccount) {
            parent.pushChildAccount(account);
          } else {
            parent.setRoot(account);
          }
        }
      };

      return account;
    };

    var Network = function(rawNetwork) {

      var _getRawAccounts = function() {
        if (!rawNetwork.customer_accounts) {
          return _getNetwork(rawNetwork.id).then(function(res) {
            rawNetwork.customer_accounts = res.customer_accounts;
            return res.customer_accounts;
          });
        }
        return $q.when(rawNetwork.customer_accounts);
      };

      var network = {
        id: rawNetwork.id,
        name: rawNetwork.name,
        dateCreated: new Date(rawNetwork.date_created),
        dateUpdated: new Date(rawNetwork.date_updated),
        totalAccounts: parseInt(rawNetwork.count),
        type: rawNetwork.network_type,
        root: null, // null is importante, undefined means unkown value, null means no data
        setRoot: function(account) {
          account.isRoot = true;
          network.root = account;
          rawNetwork.rootId = account.id;
        },
        getRootId: function() {
          return rawNetwork.root;
        },
        getTree: function() {
          if (network.root) {
            return [network.root];
          } else {
            return [];
          }
        },
        unloadRoot: function() {
          network.root = null;
          rawNetwork.customer_accounts = null;
        },
        loadRoot: function(force) {
          if (network.root === null || force) {
            return _getRawAccounts().then(function(rawAccounts) {
              var accounts = rawAccounts.map(function(rawAccount) {
                var accountId = Object.keys(rawAccount)[0];
                rawAccount = rawAccount[accountId];
                rawAccount.id = accountId;
                var account = new Account(network, rawAccount);
                return account;
              });

              // find the parent of each account.
              accounts.forEach(function(account) {
                account.findParent(accounts);
              });

              if (network.root !== null) {
                network.root.refreshTotals();
              }

            });
          }
        }
      };

      if (rawNetwork.customer_accounts) { // automatically load root if we already have the rawData
        network.loadRoot();
      }

      return network;
    };

    this.save = function(network, data) {
      var request = {
        method: 'PUT',
        url: `${ENV.EIAM_URL}/customernetworks/${network.id}`,
        data: {}
      };
      if (data.name) {
        request.data.name = data.name;
      }
      if (data.type) {
        request.data.network_type = data.type.id;
      }
      if (data.root) {
        request.data.root = data.root.id;
      }
      return $http(request).then(function(res) {
        return new Network(res.data.data);
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', err.data.data.message);
        return $q.reject(err);
      });

    };

    this.create = function(data) {
      var request = {
        method: 'POST',
        url:  `${ENV.EIAM_URL}/customernetworks`,
        data: {
          name: data.name,
          network_type: data.type.id
        }
      };
      return $http(request).then(function(res) {
        return new Network(res.data.data);
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', err.data.data.message);
        return $q.reject(err);
      });
    };

    this.delete = function(id) {
      return $http({
        method: 'delete',
        url: `${ENV.EIAM_URL}/customernetworks/${id}`
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', err.data.data.message);
        return $q.reject(err);
      });
    };

    this.get = function(id) {
      return _getNetwork(id).then(function(response) {
        return new Network(response);
      });
    };

    this.getAll = function() {
      return $http({
        method: 'GET',
        url: `${ENV.EIAM_URL}/customernetworks`
      }).then(function(raw) {
        if (!raw.data.data.customer_networks) {
          return [];
        }
        return raw.data.data.customer_networks.map(function(rawNetwork) {
          return new Network(rawNetwork);
        });
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', 'Can not get networks data');
        return $q.reject(err);
      });
    };

    this.addAccountToNetwork = function(parent, data) {
      var request = {
        method: 'POST',
        url: `${ENV.EIAM_URL}/customernetworks/${parent.network.id}/customeraccounts`,
        data: {
          customer_accounts: [
            {
              parent: parent.id,
              child: data.id
            }
          ]
        }
      };
      return $http(request).then(function(response) {
        return new Network(response.data.data);
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', err.data.data.message);
        return $q.reject(err);
      });
    };

    this.setAccountParent = function(account, newParent) {
      var request = {
        method: 'PUT',
        url: `${ENV.EIAM_URL}/customernetworks/${account.network.id}/customeraccounts`,
        data: {
          customer_accounts: [
            {
              parent: newParent.id,
              child: account.id
            }
          ]
        }
      };
      return $http(request).then(function(response) {
        return new Network(response.data.data);
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', err.data.data.message);
        return $q.reject(err);
      });
    };

    this.removeAccountFromNetwork = function(account) {
      var request;
      request = {
        method: 'DELETE',
        url: `${ENV.EIAM_URL}/customernetworks/${account.network.id}/customeraccounts`,
        data: {
          customer_accounts: [
            {
              parent: account.parent.id,
              child: account.id
            }
          ]
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
      return $http(request).then(function(response) {
        return new Network(response.data.data);
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', err.data.data.message);
        return $q.reject(err);
      });
    };

  }
]);



// WEBPACK FOOTER //
// ./src/cn/services/networksRepository.js